import React from 'react'

const About = () => {
  return (
    <div>
      <div
        class='badge-base LI-profile-badge'
        data-locale='en_US'
        data-size='medium'
        data-theme='dark'
        data-type='VERTICAL'
        data-vanity='imoh-peter-b520b8198'
        data-version='v1'
      >
        <a
          class='badge-base__link LI-simple-link'
          href='https://ng.linkedin.com/in/imoh-peter-b520b8198?trk=profile-badge'
        >
          Imoh peter
        </a>
      </div>
    </div>
  );
}

export default About